export default __webpack_public_path__ + "static/media/outcess2.f1325245.jpeg";